// AUTO-GENERATED by buildchain/scripts/generate-fa-icons.mjs — do not edit.
// Regenerated on every build/dev via the prebuild/predev npm hooks. Holds the
// FontAwesome icon subset actually reachable from the iconFa field options, the
// template icon classes and the brand-icon macro (BC-40).

import {
    faAirplay as regular_faAirplay,
    faAnchorCircleCheck as regular_faAnchorCircleCheck,
    faAngleLeft as regular_faAngleLeft,
    faAngleRight as regular_faAngleRight,
    faSortAlphaDown as regular_faSortAlphaDown,
    faSortAlt as regular_faSortAlt,
    faSortSizeDown as regular_faSortSizeDown,
    faArrowRightToCity as regular_faArrowRightToCity,
    faArrowTrendDown as regular_faArrowTrendDown,
    faArrowTrendUp as regular_faArrowTrendUp,
    faSortNumericUp as regular_faSortNumericUp,
    faSortNumericUpAlt as regular_faSortNumericUpAlt,
    faSortAlphaUp as regular_faSortAlphaUp,
    faArrowUpFromBracket as regular_faArrowUpFromBracket,
    faArrowUpRightAndArrowDownLeftFromCenter as regular_faArrowUpRightAndArrowDownLeftFromCenter,
    faArrowsSpin as regular_faArrowsSpin,
    faArrowsToEye as regular_faArrowsToEye,
    faAt as regular_faAt,
    faBalloon as regular_faBalloon,
    faBallot as regular_faBallot,
    faBarcode as regular_faBarcode,
    faTasksAlt as regular_faTasksAlt,
    faBarsSort as regular_faBarsSort,
    faStream as regular_faStream,
    faShoppingBasketAlt as regular_faShoppingBasketAlt,
    faBatteryFull as regular_faBatteryFull,
    faBatteryHalf as regular_faBatteryHalf,
    faBatterySlash as regular_faBatterySlash,
    faBatteryThreeQuarters as regular_faBatteryThreeQuarters,
    faBed as regular_faBed,
    faBedBunk as regular_faBedBunk,
    faBedEmpty as regular_faBedEmpty,
    faBedFront as regular_faBedFront,
    faBellSlash as regular_faBellSlash,
    faBells as regular_faBells,
    faBenchTree as regular_faBenchTree,
    faBinBottles as regular_faBinBottles,
    faBinBottlesRecycle as regular_faBinBottlesRecycle,
    faBinRecycle as regular_faBinRecycle,
    faBinoculars as regular_faBinoculars,
    faBiohazard as regular_faBiohazard,
    faBlanketFire as regular_faBlanketFire,
    faBlinds as regular_faBlinds,
    faWallBrick as regular_faWallBrick,
    faZap as regular_faZap,
    faBoltAuto as regular_faBoltAuto,
    faBoltLightning as regular_faBoltLightning,
    faBoltSlash as regular_faBoltSlash,
    faBook as regular_faBook,
    faBooks as regular_faBooks,
    faBoot as regular_faBoot,
    faBootHeeled as regular_faBootHeeled,
    faSoup as regular_faSoup,
    faBox as regular_faBox,
    faBoxOpen as regular_faBoxOpen,
    faBoxOpenFull as regular_faBoxOpenFull,
    faBoxTissue as regular_faBoxTissue,
    faBoxesPacking as regular_faBoxesPacking,
    faBoxesStacked as regular_faBoxesStacked,
    faBrakeWarning as regular_faBrakeWarning,
    faBreadSlice as regular_faBreadSlice,
    faBridge as regular_faBridge,
    faBridgeWater as regular_faBridgeWater,
    faBriefcaseArrowRight as regular_faBriefcaseArrowRight,
    faBriefcaseBlank as regular_faBriefcaseBlank,
    faBriefcaseMedical as regular_faBriefcaseMedical,
    faBrowser as regular_faBrowser,
    faBuilding as regular_faBuilding,
    faBuildingCircleArrowRight as regular_faBuildingCircleArrowRight,
    faBuildingCircleCheck as regular_faBuildingCircleCheck,
    faBuildingCircleExclamation as regular_faBuildingCircleExclamation,
    faBuildingCircleXmark as regular_faBuildingCircleXmark,
    faUniversity as regular_faUniversity,
    faBuildingFlag as regular_faBuildingFlag,
    faBuildingLock as regular_faBuildingLock,
    faBuildingMagnifyingGlass as regular_faBuildingMagnifyingGlass,
    faBuildingMemo as regular_faBuildingMemo,
    faBuildingNgo as regular_faBuildingNgo,
    faBuildingShield as regular_faBuildingShield,
    faBuildingUn as regular_faBuildingUn,
    faBuildingUser as regular_faBuildingUser,
    faBuildingWheat as regular_faBuildingWheat,
    faBuildings as regular_faBuildings,
    faBulldozer as regular_faBulldozer,
    faBus as regular_faBus,
    faBusinessTime as regular_faBusinessTime,
    faTram as regular_faTram,
    faCalculator as regular_faCalculator,
    faCalendarDays as regular_faCalendarDays,
    faCalendarNote as regular_faCalendarNote,
    faCalendarStar as regular_faCalendarStar,
    faCalendars as regular_faCalendars,
    faVideoHandheld as regular_faVideoHandheld,
    faCctv as regular_faCctv,
    faCameraRotate as regular_faCameraRotate,
    faCameraSecurity as regular_faCameraSecurity,
    faCameraSlash as regular_faCameraSlash,
    faCapsules as regular_faCapsules,
    faCar as regular_faCar,
    faCarBattery as regular_faCarBattery,
    faCarBolt as regular_faCarBolt,
    faCarBuilding as regular_faCarBuilding,
    faCarCircleBolt as regular_faCarCircleBolt,
    faCarGarage as regular_faCarGarage,
    faCarMirrors as regular_faCarMirrors,
    faCarTilt as regular_faCarTilt,
    faCarWrench as regular_faCarWrench,
    faCarpool as regular_faCarpool,
    faDollyFlatbedAlt as regular_faDollyFlatbedAlt,
    faDollyFlatbedEmpty as regular_faDollyFlatbedEmpty,
    faLuggageCart as regular_faLuggageCart,
    faCartMinus as regular_faCartMinus,
    faCartShoppingFast as regular_faCartShoppingFast,
    faCashRegister as regular_faCashRegister,
    faChairOffice as regular_faChairOffice,
    faChargingStation as regular_faChargingStation,
    faChartCandlestick as regular_faChartCandlestick,
    faChartDiagram as regular_faChartDiagram,
    faChartFft as regular_faChartFft,
    faChartLineUp as regular_faChartLineUp,
    faChartLineUpDown as regular_faChartLineUpDown,
    faChartNetwork as regular_faChartNetwork,
    faPieChart as regular_faPieChart,
    faChartPieSimple as regular_faChartPieSimple,
    faChartScatterBubble as regular_faChartScatterBubble,
    faChartSimple as regular_faChartSimple,
    faChartSine as regular_faChartSine,
    faChartTreeMap as regular_faChartTreeMap,
    faUserChart as regular_faUserChart,
    faChartWaterfall as regular_faChartWaterfall,
    faChildren as regular_faChildren,
    faCircle1 as regular_faCircle1,
    faCircle2 as regular_faCircle2,
    faCircle3 as regular_faCircle3,
    faCircle4 as regular_faCircle4,
    faCircle5 as regular_faCircle5,
    faCircle6 as regular_faCircle6,
    faCircleCheck as regular_faCircleCheck,
    faInfoCircle as regular_faInfoCircle,
    faCircleWifi as regular_faCircleWifi,
    faXmarkCircle as regular_faXmarkCircle,
    faCity as regular_faCity,
    faHistory as regular_faHistory,
    faClockThree as regular_faClockThree,
    faFog as regular_faFog,
    faCloudHail as regular_faCloudHail,
    faClouds as regular_faClouds,
    faCoins as regular_faCoins,
    faContainerStorage as regular_faContainerStorage,
    faConveyorBelt as regular_faConveyorBelt,
    faConveyorBeltArm as regular_faConveyorBeltArm,
    faConveyorBeltBoxes as regular_faConveyorBeltBoxes,
    faCreditCardFront as regular_faCreditCardFront,
    faDesktopAlt as regular_faDesktopAlt,
    faDialMedLow as regular_faDialMedLow,
    faDisplayChartUp as regular_faDisplayChartUp,
    faDollyBox as regular_faDollyBox,
    faDollyEmpty as regular_faDollyEmpty,
    faDoorClosed as regular_faDoorClosed,
    faDrone as regular_faDrone,
    faDryer as regular_faDryer,
    faDumbbell as regular_faDumbbell,
    faDumpster as regular_faDumpster,
    faGlobeAmericas as regular_faGlobeAmericas,
    faGlobeEurope as regular_faGlobeEurope,
    faEngine as regular_faEngine,
    faEnvelopeOpenText as regular_faEnvelopeOpenText,
    faEnvelopes as regular_faEnvelopes,
    faEscalator as regular_faEscalator,
    faLaugh as regular_faLaugh,
    faFaceShush as regular_faFaceShush,
    faFanTable as regular_faFanTable,
    faFaucet as regular_faFaucet,
    faFileCheck as regular_faFileCheck,
    faFileText as regular_faFileText,
    faFilmSimple as regular_faFilmSimple,
    faFilter as regular_faFilter,
    faFingerprint as regular_faFingerprint,
    faForklift as regular_faForklift,
    faFort as regular_faFort,
    faGasPump as regular_faGasPump,
    faGear as regular_faGear,
    faGears as regular_faGears,
    faGift as regular_faGift,
    faGlobe as regular_faGlobe,
    faHandshakeSimple as regular_faHandshakeSimple,
    faHatChef as regular_faHatChef,
    faHeadSideBrain as regular_faHeadSideBrain,
    faHeadSideMask as regular_faHeadSideMask,
    faHeadphonesSimple as regular_faHeadphonesSimple,
    faHeadset as regular_faHeadset,
    faHillAvalanche as regular_faHillAvalanche,
    faHillRockslide as regular_faHillRockslide,
    faHospitalUser as regular_faHospitalUser,
    faHospitals as regular_faHospitals,
    faHourglassEmpty as regular_faHourglassEmpty,
    faHourglassClock as regular_faHourglassClock,
    faHourglassEnd as regular_faHourglassEnd,
    faHourglassHalf as regular_faHourglassHalf,
    faHouseBlank as regular_faHouseBlank,
    faHouseBuilding as regular_faHouseBuilding,
    faHouseChimney as regular_faHouseChimney,
    faHouseChimneyBlank as regular_faHouseChimneyBlank,
    faHouseDay as regular_faHouseDay,
    faHouseFloodWater as regular_faHouseFloodWater,
    faHouseFloodWaterCircleArrowRight as regular_faHouseFloodWaterCircleArrowRight,
    faHouseHeart as regular_faHouseHeart,
    faHouseMedicalCircleCheck as regular_faHouseMedicalCircleCheck,
    faHouseTree as regular_faHouseTree,
    faHouseTurret as regular_faHouseTurret,
    faImagePolaroidUser as regular_faImagePolaroidUser,
    faPortrait as regular_faPortrait,
    faImageSlash as regular_faImageSlash,
    faImages as regular_faImages,
    faInboxIn as regular_faInboxIn,
    faInboxOut as regular_faInboxOut,
    faInboxes as regular_faInboxes,
    faIndustry as regular_faIndustry,
    faInfinity as regular_faInfinity,
    faInfo as regular_faInfo,
    faKitMedical as regular_faKitMedical,
    faLampDesk as regular_faLampDesk,
    faLampFloor as regular_faLampFloor,
    faLampStreet as regular_faLampStreet,
    faLandmark as regular_faLandmark,
    faLaptop as regular_faLaptop,
    faLaptopFile as regular_faLaptopFile,
    faLeaf as regular_faLeaf,
    faLeafOak as regular_faLeafOak,
    faLeafyGreen as regular_faLeafyGreen,
    faLeftFromBracket as regular_faLeftFromBracket,
    faLightCeiling as regular_faLightCeiling,
    faLightEmergency as regular_faLightEmergency,
    faLightbulbOn as regular_faLightbulbOn,
    faLightsHoliday as regular_faLightsHoliday,
    faLineColumns as regular_faLineColumns,
    faLinkSimple as regular_faLinkSimple,
    faLinkSimpleSlash as regular_faLinkSimpleSlash,
    faTasks as regular_faTasks,
    faListDropdown as regular_faListDropdown,
    faListTree as regular_faListTree,
    faListUl as regular_faListUl,
    faLocationArrowUp as regular_faLocationArrowUp,
    faMapMarkerCheck as regular_faMapMarkerCheck,
    faMapMarkerAlt as regular_faMapMarkerAlt,
    faMapMarker as regular_faMapMarker,
    faLocationPinLock as regular_faLocationPinLock,
    faLock as regular_faLock,
    faLockKeyhole as regular_faLockKeyhole,
    faLockOpen as regular_faLockOpen,
    faLoveseat as regular_faLoveseat,
    faSearchMinus as regular_faSearchMinus,
    faMap as regular_faMap,
    faMapMarked as regular_faMapMarked,
    faMapMarkedAlt as regular_faMapMarkedAlt,
    faMaskFace as regular_faMaskFace,
    faTheaterMasks as regular_faTheaterMasks,
    faMedal as regular_faMedal,
    faMemo as regular_faMemo,
    faMemoCircleCheck as regular_faMemoCircleCheck,
    faMemoCircleInfo as regular_faMemoCircleInfo,
    faMerge as regular_faMerge,
    faMessage as regular_faMessage,
    faMessageExclamation as regular_faMessageExclamation,
    faMessageHeart as regular_faMessageHeart,
    faMessageImage as regular_faMessageImage,
    faMessageLines as regular_faMessageLines,
    faMessages as regular_faMessages,
    faMessagesQuestion as regular_faMessagesQuestion,
    faMeter as regular_faMeter,
    faMeterBolt as regular_faMeterBolt,
    faMicrochipAi as regular_faMicrochipAi,
    faMicrophone as regular_faMicrophone,
    faMicrowave as regular_faMicrowave,
    faMoneyBillsSimple as regular_faMoneyBillsSimple,
    faMoneyCheckDollar as regular_faMoneyCheckDollar,
    faMoneyFromBracket as regular_faMoneyFromBracket,
    faMonitorWaveform as regular_faMonitorWaveform,
    faMoon as regular_faMoon,
    faMoped as regular_faMoped,
    faMotorcycle as regular_faMotorcycle,
    faMountainCity as regular_faMountainCity,
    faMountainSun as regular_faMountainSun,
    faMountains as regular_faMountains,
    faMugTea as regular_faMugTea,
    faMusic as regular_faMusic,
    faNetworkWired as regular_faNetworkWired,
    faNotebook as regular_faNotebook,
    faObjectsAlignBottom as regular_faObjectsAlignBottom,
    faObjectsAlignCenterHorizontal as regular_faObjectsAlignCenterHorizontal,
    faObjectsAlignCenterVertical as regular_faObjectsAlignCenterVertical,
    faObjectsAlignLeft as regular_faObjectsAlignLeft,
    faObjectsAlignRight as regular_faObjectsAlignRight,
    faObjectsColumn as regular_faObjectsColumn,
    faOilCanDrip as regular_faOilCanDrip,
    faOilWell as regular_faOilWell,
    faOutlet as regular_faOutlet,
    faOven as regular_faOven,
    faPallet as regular_faPallet,
    faPalletBox as regular_faPalletBox,
    faPalletBoxes as regular_faPalletBoxes,
    faPaperPlane as regular_faPaperPlane,
    faPaperclipVertical as regular_faPaperclipVertical,
    faPassport as regular_faPassport,
    faPause as regular_faPause,
    faPenNib as regular_faPenNib,
    faPeopleRoof as regular_faPeopleRoof,
    faPersonDollyEmpty as regular_faPersonDollyEmpty,
    faPersonWalkingLuggage as regular_faPersonWalkingLuggage,
    faPhoneIntercom as regular_faPhoneIntercom,
    faPhoneOffice as regular_faPhoneOffice,
    faPhoneSlash as regular_faPhoneSlash,
    faVolumeControlPhone as regular_faVolumeControlPhone,
    faPlane as regular_faPlane,
    faPlaneArrival as regular_faPlaneArrival,
    faPlaneDeparture as regular_faPlaneDeparture,
    faPlaneEngines as regular_faPlaneEngines,
    faPlanetMoon as regular_faPlanetMoon,
    faPlay as regular_faPlay,
    faPlugCircleBolt as regular_faPlugCircleBolt,
    faPlugCircleCheck as regular_faPlugCircleCheck,
    faPresentationScreen as regular_faPresentationScreen,
    faQuotes as regular_faQuotes,
    faRadiation as regular_faRadiation,
    faRadio as regular_faRadio,
    faRadioTuner as regular_faRadioTuner,
    faRampLoading as regular_faRampLoading,
    faRectanglesMixed as regular_faRectanglesMixed,
    faRecycle as regular_faRecycle,
    faRepeat as regular_faRepeat,
    faRestroomSimple as regular_faRestroomSimple,
    faRoad as regular_faRoad,
    faRoadBarrier as regular_faRoadBarrier,
    faRoadBridge as regular_faRoadBridge,
    faRoadLock as regular_faRoadLock,
    faRobotAstromech as regular_faRobotAstromech,
    faRocketLaunch as regular_faRocketLaunch,
    faRouter as regular_faRouter,
    faRulerCombined as regular_faRulerCombined,
    faRulerHorizontal as regular_faRulerHorizontal,
    faScaleUnbalancedFlip as regular_faScaleUnbalancedFlip,
    faScannerKeyboard as regular_faScannerKeyboard,
    faSchool as regular_faSchool,
    faSchoolFlag as regular_faSchoolFlag,
    faSdCard as regular_faSdCard,
    faSdCards as regular_faSdCards,
    faSprout as regular_faSprout,
    faSensorSmoke as regular_faSensorSmoke,
    faServer as regular_faServer,
    faShelves as regular_faShelves,
    faShieldHalved as regular_faShieldHalved,
    faShip as regular_faShip,
    faShirtLongSleeve as regular_faShirtLongSleeve,
    faShoePrints as regular_faShoePrints,
    faStoreAlt as regular_faStoreAlt,
    faShovel as regular_faShovel,
    faShower as regular_faShower,
    faSignPost as regular_faSignPost,
    faSignPosts as regular_faSignPosts,
    faSignalBarsStrong as regular_faSignalBarsStrong,
    faSignalSlash as regular_faSignalSlash,
    faSitemap as regular_faSitemap,
    faSlider as regular_faSlider,
    faSlidersSimple as regular_faSlidersSimple,
    faSmog as regular_faSmog,
    faSmoking as regular_faSmoking,
    faSnowBlowing as regular_faSnowBlowing,
    faSnowflake as regular_faSnowflake,
    faSolarPanel as regular_faSolarPanel,
    faSolarSystem as regular_faSolarSystem,
    faSparkle as regular_faSparkle,
    faSpeaker as regular_faSpeaker,
    faSpellCheck as regular_faSpellCheck,
    faSplit as regular_faSplit,
    faSprayCan as regular_faSprayCan,
    faSprinklerCeiling as regular_faSprinklerCeiling,
    faSquare0 as regular_faSquare0,
    faSquareInfo as regular_faSquareInfo,
    faStairs as regular_faStairs,
    faStamp as regular_faStamp,
    faStapler as regular_faStapler,
    faStar as regular_faStar,
    faStarOfLife as regular_faStarOfLife,
    faStoreLock as regular_faStoreLock,
    faStoreSlash as regular_faStoreSlash,
    faSun as regular_faSun,
    faTh as regular_faTh,
    faThLarge as regular_faThLarge,
    faTableCellsRowLock as regular_faTableCellsRowLock,
    faTableCellsRowUnlock as regular_faTableCellsRowUnlock,
    faTableLayout as regular_faTableLayout,
    faTablePicnic as regular_faTablePicnic,
    faTableTennisPaddleBall as regular_faTableTennisPaddleBall,
    faTape as regular_faTape,
    faTaxi as regular_faTaxi,
    faThermometerFull as regular_faThermometerFull,
    faThermometerHalf as regular_faThermometerHalf,
    faTent as regular_faTent,
    faTentDoublePeak as regular_faTentDoublePeak,
    faTicketsSimple as regular_faTicketsSimple,
    faTimer as regular_faTimer,
    faToggleLargeOn as regular_faToggleLargeOn,
    faToilet as regular_faToilet,
    faToiletPaperBlank as regular_faToiletPaperBlank,
    faToolbox as regular_faToolbox,
    faTowerBroadcast as regular_faTowerBroadcast,
    faTowerCell as regular_faTowerCell,
    faTractor as regular_faTractor,
    faTrafficCone as regular_faTrafficCone,
    faTrafficLightGo as regular_faTrafficLightGo,
    faTrailer as regular_faTrailer,
    faTrainSubway as regular_faTrainSubway,
    faTrainTrack as regular_faTrainTrack,
    faTrainTram as regular_faTrainTram,
    faTrainTunnel as regular_faTrainTunnel,
    faTrash as regular_faTrash,
    faTrashCan as regular_faTrashCan,
    faTrashList as regular_faTrashList,
    faTreeCity as regular_faTreeCity,
    faTreeDeciduous as regular_faTreeDeciduous,
    faTrowel as regular_faTrowel,
    faTruck as regular_faTruck,
    faTruckArrowRight as regular_faTruckArrowRight,
    faTruckBolt as regular_faTruckBolt,
    faTruckClock as regular_faTruckClock,
    faTruckContainer as regular_faTruckContainer,
    faTruckContainerEmpty as regular_faTruckContainerEmpty,
    faTruckFast as regular_faTruckFast,
    faTruckField as regular_faTruckField,
    faTruckFire as regular_faTruckFire,
    faTruckFront as regular_faTruckFront,
    faTruckLadder as regular_faTruckLadder,
    faTruckMedical as regular_faTruckMedical,
    faTruckMoving as regular_faTruckMoving,
    faTruckPlane as regular_faTruckPlane,
    faTruckTow as regular_faTruckTow,
    faTruckUtensils as regular_faTruckUtensils,
    faTurntable as regular_faTurntable,
    faTvAlt as regular_faTvAlt,
    faTvMusic as regular_faTvMusic,
    faUmbrella as regular_faUmbrella,
    faUpToLine as regular_faUpToLine,
    faUsbDrive as regular_faUsbDrive,
    faUsersGear as regular_faUsersGear,
    faUsersLine as regular_faUsersLine,
    faVault as regular_faVault,
    faVials as regular_faVials,
    faWallet as regular_faWallet,
    faWarehouse as regular_faWarehouse,
    faWarehouseFull as regular_faWarehouseFull,
    faWashingMachine as regular_faWashingMachine,
    faWatch as regular_faWatch,
    faWater as regular_faWater,
    faWaterLadder as regular_faWaterLadder,
    faWave as regular_faWave,
    faWeightHanging as regular_faWeightHanging,
    faWheatAwn as regular_faWheatAwn,
    faWheatAwnCircleExclamation as regular_faWheatAwnCircleExclamation,
    faWheelchair as regular_faWheelchair,
    faWindTurbine as regular_faWindTurbine,
    faWindWarning as regular_faWindWarning,
    faWindowFrame as regular_faWindowFrame,
    faWindsock as regular_faWindsock,
} from '@awesome.me/kit-bc84d927de/icons/classic/regular'

import {
    faArrowRight as solid_faArrowRight,
    faArrowUpRight as solid_faArrowUpRight,
    faCaretRight as solid_faCaretRight,
    faChevronDown as solid_faChevronDown,
    faChevronLeft as solid_faChevronLeft,
    faChevronRight as solid_faChevronRight,
    faChevronUp as solid_faChevronUp,
    faCircle1 as solid_faCircle1,
    faCircle2 as solid_faCircle2,
    faCircle3 as solid_faCircle3,
    faCircle4 as solid_faCircle4,
    faCircle5 as solid_faCircle5,
    faCircle6 as solid_faCircle6,
    faCircle7 as solid_faCircle7,
    faCircle8 as solid_faCircle8,
    faCircle9 as solid_faCircle9,
    faPodcast as solid_faPodcast,
} from '@awesome.me/kit-bc84d927de/icons/classic/solid'

import {
    faFacebook as brands_faFacebook,
    faInstagram as brands_faInstagram,
    faLinkedinIn as brands_faLinkedinIn,
    faSoundcloud as brands_faSoundcloud,
    faSpotify as brands_faSpotify,
    faXTwitter as brands_faXTwitter,
    faYoutube as brands_faYoutube,
} from '@awesome.me/kit-bc84d927de/icons/classic/brands'

import {
    faIconAddedValue as custom_faIconAddedValue,
    faIconAtom as custom_faIconAtom,
    faIconCrane as custom_faIconCrane,
    faIconGreenPower as custom_faIconGreenPower,
    faIconLowerCo2 as custom_faIconLowerCo2,
    faIconNoFossilFuels as custom_faIconNoFossilFuels,
    faIconSolarPanel as custom_faIconSolarPanel,
    faIconWarehouse as custom_faIconWarehouse,
} from '@awesome.me/kit-bc84d927de/icons/kit/custom'

export const icons = [
    regular_faAirplay,
    regular_faAnchorCircleCheck,
    regular_faAngleLeft,
    regular_faAngleRight,
    regular_faSortAlphaDown,
    regular_faSortAlt,
    regular_faSortSizeDown,
    regular_faArrowRightToCity,
    regular_faArrowTrendDown,
    regular_faArrowTrendUp,
    regular_faSortNumericUp,
    regular_faSortNumericUpAlt,
    regular_faSortAlphaUp,
    regular_faArrowUpFromBracket,
    regular_faArrowUpRightAndArrowDownLeftFromCenter,
    regular_faArrowsSpin,
    regular_faArrowsToEye,
    regular_faAt,
    regular_faBalloon,
    regular_faBallot,
    regular_faBarcode,
    regular_faTasksAlt,
    regular_faBarsSort,
    regular_faStream,
    regular_faShoppingBasketAlt,
    regular_faBatteryFull,
    regular_faBatteryHalf,
    regular_faBatterySlash,
    regular_faBatteryThreeQuarters,
    regular_faBed,
    regular_faBedBunk,
    regular_faBedEmpty,
    regular_faBedFront,
    regular_faBellSlash,
    regular_faBells,
    regular_faBenchTree,
    regular_faBinBottles,
    regular_faBinBottlesRecycle,
    regular_faBinRecycle,
    regular_faBinoculars,
    regular_faBiohazard,
    regular_faBlanketFire,
    regular_faBlinds,
    regular_faWallBrick,
    regular_faZap,
    regular_faBoltAuto,
    regular_faBoltLightning,
    regular_faBoltSlash,
    regular_faBook,
    regular_faBooks,
    regular_faBoot,
    regular_faBootHeeled,
    regular_faSoup,
    regular_faBox,
    regular_faBoxOpen,
    regular_faBoxOpenFull,
    regular_faBoxTissue,
    regular_faBoxesPacking,
    regular_faBoxesStacked,
    regular_faBrakeWarning,
    regular_faBreadSlice,
    regular_faBridge,
    regular_faBridgeWater,
    regular_faBriefcaseArrowRight,
    regular_faBriefcaseBlank,
    regular_faBriefcaseMedical,
    regular_faBrowser,
    regular_faBuilding,
    regular_faBuildingCircleArrowRight,
    regular_faBuildingCircleCheck,
    regular_faBuildingCircleExclamation,
    regular_faBuildingCircleXmark,
    regular_faUniversity,
    regular_faBuildingFlag,
    regular_faBuildingLock,
    regular_faBuildingMagnifyingGlass,
    regular_faBuildingMemo,
    regular_faBuildingNgo,
    regular_faBuildingShield,
    regular_faBuildingUn,
    regular_faBuildingUser,
    regular_faBuildingWheat,
    regular_faBuildings,
    regular_faBulldozer,
    regular_faBus,
    regular_faBusinessTime,
    regular_faTram,
    regular_faCalculator,
    regular_faCalendarDays,
    regular_faCalendarNote,
    regular_faCalendarStar,
    regular_faCalendars,
    regular_faVideoHandheld,
    regular_faCctv,
    regular_faCameraRotate,
    regular_faCameraSecurity,
    regular_faCameraSlash,
    regular_faCapsules,
    regular_faCar,
    regular_faCarBattery,
    regular_faCarBolt,
    regular_faCarBuilding,
    regular_faCarCircleBolt,
    regular_faCarGarage,
    regular_faCarMirrors,
    regular_faCarTilt,
    regular_faCarWrench,
    regular_faCarpool,
    regular_faDollyFlatbedAlt,
    regular_faDollyFlatbedEmpty,
    regular_faLuggageCart,
    regular_faCartMinus,
    regular_faCartShoppingFast,
    regular_faCashRegister,
    regular_faChairOffice,
    regular_faChargingStation,
    regular_faChartCandlestick,
    regular_faChartDiagram,
    regular_faChartFft,
    regular_faChartLineUp,
    regular_faChartLineUpDown,
    regular_faChartNetwork,
    regular_faPieChart,
    regular_faChartPieSimple,
    regular_faChartScatterBubble,
    regular_faChartSimple,
    regular_faChartSine,
    regular_faChartTreeMap,
    regular_faUserChart,
    regular_faChartWaterfall,
    regular_faChildren,
    regular_faCircle1,
    regular_faCircle2,
    regular_faCircle3,
    regular_faCircle4,
    regular_faCircle5,
    regular_faCircle6,
    regular_faCircleCheck,
    regular_faInfoCircle,
    regular_faCircleWifi,
    regular_faXmarkCircle,
    regular_faCity,
    regular_faHistory,
    regular_faClockThree,
    regular_faFog,
    regular_faCloudHail,
    regular_faClouds,
    regular_faCoins,
    regular_faContainerStorage,
    regular_faConveyorBelt,
    regular_faConveyorBeltArm,
    regular_faConveyorBeltBoxes,
    regular_faCreditCardFront,
    regular_faDesktopAlt,
    regular_faDialMedLow,
    regular_faDisplayChartUp,
    regular_faDollyBox,
    regular_faDollyEmpty,
    regular_faDoorClosed,
    regular_faDrone,
    regular_faDryer,
    regular_faDumbbell,
    regular_faDumpster,
    regular_faGlobeAmericas,
    regular_faGlobeEurope,
    regular_faEngine,
    regular_faEnvelopeOpenText,
    regular_faEnvelopes,
    regular_faEscalator,
    regular_faLaugh,
    regular_faFaceShush,
    regular_faFanTable,
    regular_faFaucet,
    regular_faFileCheck,
    regular_faFileText,
    regular_faFilmSimple,
    regular_faFilter,
    regular_faFingerprint,
    regular_faForklift,
    regular_faFort,
    regular_faGasPump,
    regular_faGear,
    regular_faGears,
    regular_faGift,
    regular_faGlobe,
    regular_faHandshakeSimple,
    regular_faHatChef,
    regular_faHeadSideBrain,
    regular_faHeadSideMask,
    regular_faHeadphonesSimple,
    regular_faHeadset,
    regular_faHillAvalanche,
    regular_faHillRockslide,
    regular_faHospitalUser,
    regular_faHospitals,
    regular_faHourglassEmpty,
    regular_faHourglassClock,
    regular_faHourglassEnd,
    regular_faHourglassHalf,
    regular_faHouseBlank,
    regular_faHouseBuilding,
    regular_faHouseChimney,
    regular_faHouseChimneyBlank,
    regular_faHouseDay,
    regular_faHouseFloodWater,
    regular_faHouseFloodWaterCircleArrowRight,
    regular_faHouseHeart,
    regular_faHouseMedicalCircleCheck,
    regular_faHouseTree,
    regular_faHouseTurret,
    regular_faImagePolaroidUser,
    regular_faPortrait,
    regular_faImageSlash,
    regular_faImages,
    regular_faInboxIn,
    regular_faInboxOut,
    regular_faInboxes,
    regular_faIndustry,
    regular_faInfinity,
    regular_faInfo,
    regular_faKitMedical,
    regular_faLampDesk,
    regular_faLampFloor,
    regular_faLampStreet,
    regular_faLandmark,
    regular_faLaptop,
    regular_faLaptopFile,
    regular_faLeaf,
    regular_faLeafOak,
    regular_faLeafyGreen,
    regular_faLeftFromBracket,
    regular_faLightCeiling,
    regular_faLightEmergency,
    regular_faLightbulbOn,
    regular_faLightsHoliday,
    regular_faLineColumns,
    regular_faLinkSimple,
    regular_faLinkSimpleSlash,
    regular_faTasks,
    regular_faListDropdown,
    regular_faListTree,
    regular_faListUl,
    regular_faLocationArrowUp,
    regular_faMapMarkerCheck,
    regular_faMapMarkerAlt,
    regular_faMapMarker,
    regular_faLocationPinLock,
    regular_faLock,
    regular_faLockKeyhole,
    regular_faLockOpen,
    regular_faLoveseat,
    regular_faSearchMinus,
    regular_faMap,
    regular_faMapMarked,
    regular_faMapMarkedAlt,
    regular_faMaskFace,
    regular_faTheaterMasks,
    regular_faMedal,
    regular_faMemo,
    regular_faMemoCircleCheck,
    regular_faMemoCircleInfo,
    regular_faMerge,
    regular_faMessage,
    regular_faMessageExclamation,
    regular_faMessageHeart,
    regular_faMessageImage,
    regular_faMessageLines,
    regular_faMessages,
    regular_faMessagesQuestion,
    regular_faMeter,
    regular_faMeterBolt,
    regular_faMicrochipAi,
    regular_faMicrophone,
    regular_faMicrowave,
    regular_faMoneyBillsSimple,
    regular_faMoneyCheckDollar,
    regular_faMoneyFromBracket,
    regular_faMonitorWaveform,
    regular_faMoon,
    regular_faMoped,
    regular_faMotorcycle,
    regular_faMountainCity,
    regular_faMountainSun,
    regular_faMountains,
    regular_faMugTea,
    regular_faMusic,
    regular_faNetworkWired,
    regular_faNotebook,
    regular_faObjectsAlignBottom,
    regular_faObjectsAlignCenterHorizontal,
    regular_faObjectsAlignCenterVertical,
    regular_faObjectsAlignLeft,
    regular_faObjectsAlignRight,
    regular_faObjectsColumn,
    regular_faOilCanDrip,
    regular_faOilWell,
    regular_faOutlet,
    regular_faOven,
    regular_faPallet,
    regular_faPalletBox,
    regular_faPalletBoxes,
    regular_faPaperPlane,
    regular_faPaperclipVertical,
    regular_faPassport,
    regular_faPause,
    regular_faPenNib,
    regular_faPeopleRoof,
    regular_faPersonDollyEmpty,
    regular_faPersonWalkingLuggage,
    regular_faPhoneIntercom,
    regular_faPhoneOffice,
    regular_faPhoneSlash,
    regular_faVolumeControlPhone,
    regular_faPlane,
    regular_faPlaneArrival,
    regular_faPlaneDeparture,
    regular_faPlaneEngines,
    regular_faPlanetMoon,
    regular_faPlay,
    regular_faPlugCircleBolt,
    regular_faPlugCircleCheck,
    regular_faPresentationScreen,
    regular_faQuotes,
    regular_faRadiation,
    regular_faRadio,
    regular_faRadioTuner,
    regular_faRampLoading,
    regular_faRectanglesMixed,
    regular_faRecycle,
    regular_faRepeat,
    regular_faRestroomSimple,
    regular_faRoad,
    regular_faRoadBarrier,
    regular_faRoadBridge,
    regular_faRoadLock,
    regular_faRobotAstromech,
    regular_faRocketLaunch,
    regular_faRouter,
    regular_faRulerCombined,
    regular_faRulerHorizontal,
    regular_faScaleUnbalancedFlip,
    regular_faScannerKeyboard,
    regular_faSchool,
    regular_faSchoolFlag,
    regular_faSdCard,
    regular_faSdCards,
    regular_faSprout,
    regular_faSensorSmoke,
    regular_faServer,
    regular_faShelves,
    regular_faShieldHalved,
    regular_faShip,
    regular_faShirtLongSleeve,
    regular_faShoePrints,
    regular_faStoreAlt,
    regular_faShovel,
    regular_faShower,
    regular_faSignPost,
    regular_faSignPosts,
    regular_faSignalBarsStrong,
    regular_faSignalSlash,
    regular_faSitemap,
    regular_faSlider,
    regular_faSlidersSimple,
    regular_faSmog,
    regular_faSmoking,
    regular_faSnowBlowing,
    regular_faSnowflake,
    regular_faSolarPanel,
    regular_faSolarSystem,
    regular_faSparkle,
    regular_faSpeaker,
    regular_faSpellCheck,
    regular_faSplit,
    regular_faSprayCan,
    regular_faSprinklerCeiling,
    regular_faSquare0,
    regular_faSquareInfo,
    regular_faStairs,
    regular_faStamp,
    regular_faStapler,
    regular_faStar,
    regular_faStarOfLife,
    regular_faStoreLock,
    regular_faStoreSlash,
    regular_faSun,
    regular_faTh,
    regular_faThLarge,
    regular_faTableCellsRowLock,
    regular_faTableCellsRowUnlock,
    regular_faTableLayout,
    regular_faTablePicnic,
    regular_faTableTennisPaddleBall,
    regular_faTape,
    regular_faTaxi,
    regular_faThermometerFull,
    regular_faThermometerHalf,
    regular_faTent,
    regular_faTentDoublePeak,
    regular_faTicketsSimple,
    regular_faTimer,
    regular_faToggleLargeOn,
    regular_faToilet,
    regular_faToiletPaperBlank,
    regular_faToolbox,
    regular_faTowerBroadcast,
    regular_faTowerCell,
    regular_faTractor,
    regular_faTrafficCone,
    regular_faTrafficLightGo,
    regular_faTrailer,
    regular_faTrainSubway,
    regular_faTrainTrack,
    regular_faTrainTram,
    regular_faTrainTunnel,
    regular_faTrash,
    regular_faTrashCan,
    regular_faTrashList,
    regular_faTreeCity,
    regular_faTreeDeciduous,
    regular_faTrowel,
    regular_faTruck,
    regular_faTruckArrowRight,
    regular_faTruckBolt,
    regular_faTruckClock,
    regular_faTruckContainer,
    regular_faTruckContainerEmpty,
    regular_faTruckFast,
    regular_faTruckField,
    regular_faTruckFire,
    regular_faTruckFront,
    regular_faTruckLadder,
    regular_faTruckMedical,
    regular_faTruckMoving,
    regular_faTruckPlane,
    regular_faTruckTow,
    regular_faTruckUtensils,
    regular_faTurntable,
    regular_faTvAlt,
    regular_faTvMusic,
    regular_faUmbrella,
    regular_faUpToLine,
    regular_faUsbDrive,
    regular_faUsersGear,
    regular_faUsersLine,
    regular_faVault,
    regular_faVials,
    regular_faWallet,
    regular_faWarehouse,
    regular_faWarehouseFull,
    regular_faWashingMachine,
    regular_faWatch,
    regular_faWater,
    regular_faWaterLadder,
    regular_faWave,
    regular_faWeightHanging,
    regular_faWheatAwn,
    regular_faWheatAwnCircleExclamation,
    regular_faWheelchair,
    regular_faWindTurbine,
    regular_faWindWarning,
    regular_faWindowFrame,
    regular_faWindsock,
    solid_faArrowRight,
    solid_faArrowUpRight,
    solid_faCaretRight,
    solid_faChevronDown,
    solid_faChevronLeft,
    solid_faChevronRight,
    solid_faChevronUp,
    solid_faCircle1,
    solid_faCircle2,
    solid_faCircle3,
    solid_faCircle4,
    solid_faCircle5,
    solid_faCircle6,
    solid_faCircle7,
    solid_faCircle8,
    solid_faCircle9,
    solid_faPodcast,
    brands_faFacebook,
    brands_faInstagram,
    brands_faLinkedinIn,
    brands_faSoundcloud,
    brands_faSpotify,
    brands_faXTwitter,
    brands_faYoutube,
    custom_faIconAddedValue,
    custom_faIconAtom,
    custom_faIconCrane,
    custom_faIconGreenPower,
    custom_faIconLowerCo2,
    custom_faIconNoFossilFuels,
    custom_faIconSolarPanel,
    custom_faIconWarehouse,
];
